import { ReviewPeriodData } from "src/store/api/generatedApi";

type ColorVariant = "main" | "light";

export const getReviewPeriodColor = (
  period: ReviewPeriodData,
  userUid: string | null,
  variant: ColorVariant = "main"
): string => {
  const isVerified = period.verified_at != null;
  const isAssignedToMe = userUid && period.assigned_to_id === userUid;
  const isAssignedToOther = period.assigned_to_id && !isAssignedToMe;

  if (isVerified) {
    return variant === "main" ? "success.main" : "success.light";
  } else if (isAssignedToMe) {
    return variant === "main" ? "info.main" : "info.light";
  } else if (isAssignedToOther) {
    return variant === "main" ? "warning.main" : "warning.light";
  } else {
    return variant === "main" ? "error.main" : "error.light";
  }
};
